import base from './dev'

base.env = 'deploy'
base.api.host = 'https://data.lingzhuyun.com/java' // java源
base.api.pythonHost = 'https://wb.lingzhuyun.com/api' // python 源
export default base



// WEBPACK FOOTER //
// ./src/env/deploy.js